import React, { useState, useEffect } from "react";
import BookingReportTable from "./Components/BookingReportTable";
import api from "../../../../../api/axios";

const BookingReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [rawData, setRawData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [bookingStatus, setBookingStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  const [loading, setLoading] = useState(false);

  // ------------------ Load API ------------------
  useEffect(() => {
    loadReports();
  }, []);

  const loadReports = async () => {
    setLoading(true);
    try {
      const res = await api.get("pms/reservation-payments");
      const list = res.data.data || [];
      setRawData(list);
      setFilteredData(list);
    } catch (error) {
      console.error("Failed loading API", error);
    } finally {
      setLoading(false);
    }
  };

  // ------------------ Apply Filters ------------------
  const applyFilters = () => {
    let data = [...rawData];

    if (fromDate) data = data.filter((x) => x.check_in >= fromDate);
    if (toDate) data = data.filter((x) => x.check_out <= toDate);

    if (bookingStatus) data = data.filter((x) => x.status === bookingStatus);
    if (paymentStatus)
      data = data.filter((x) => x.payment_status === paymentStatus);

    setFilteredData(data);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      {/* --------- Global Loader ---------- */}
      {loading && (
        <div className="text-center my-4">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          ></div>
          <p className="mt-2 fw-bold text-primary">Loading Reports...</p>
        </div>
      )}

      {!loading && (
        <div className="row g-3">
          <div className="col-sm-12">
            <h3 className="fw-bold mb-0">Booking Reports</h3>
          </div>

          {/* ---------------- FILTER UI ---------------- */}
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h6 className="card-title">Search Reports Here</h6>
              </div>

              <div className="card-body">
                <div className="row g-3">
                  {/* From Date */}
                  <div className="col-md-6">
                    <label className="form-label text-muted">From *</label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-calendar-plus"></i>
                      </span>
                      <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* To Date */}
                  <div className="col-md-6">
                    <label className="form-label text-muted">To *</label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-calendar-minus"></i>
                      </span>
                      <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Booking Status */}
                  <div className="col-md-6">
                    <label className="form-label text-muted">
                      Booking Status
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-house"></i>
                      </span>
                      <select
                        className="form-select"
                        value={bookingStatus}
                        onChange={(e) => setBookingStatus(e.target.value)}
                      >
                        <option value="">Find Booking Status</option>
                        <option value="reserved">Reserved</option>
                        <option value="cancel">Cancel</option>
                        <option value="checked_in">Check In</option>
                        <option value="checked_out">Check Out</option>
                      </select>
                    </div>
                  </div>

                  {/* Payment Status */}
                  <div className="col-md-6">
                    <label className="form-label text-muted">
                      Payment Status
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-cash"></i>
                      </span>
                      <select
                        className="form-select"
                        value={paymentStatus}
                        onChange={(e) => setPaymentStatus(e.target.value)}
                      >
                        <option value="">Find Payment Status</option>
                        <option value="Pending">Pending</option>
                        <option value="complete">Complete</option>
                      </select>
                    </div>
                  </div>

                  {/* Search button */}
                  <div className="col-md-12 text-end">
                    <button
                      className="btn btn-primary py-2 px-5"
                      onClick={applyFilters}
                      disabled={loading}
                    >
                      {loading ? "Please wait..." : "Search"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ---------------- TABLE ---------------- */}
          <div className="col-sm-12">
            <div className="card">
              <div className="card-body">
                <BookingReportTable tableData={filteredData} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingReport;
